import axios from "axios";
import crypto from "crypto-js";
import { API } from "..";

export const Authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    const encrypted_data = crypto.AES.encrypt(
      JSON.stringify(data),
      "shubhamraj"
    ).toString();

    localStorage.setItem("jwt", JSON.stringify(encrypted_data));

    next();
  }
};

export const signout = (next) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("jwt");
    return axios.get(`${API}logout`).then((res) => {
      next();
    });
  }
};

export const isAuthenticated = () => {
  if (typeof window === "undefined") {
    return false;
  } else if (localStorage.getItem("jwt")) {
    const data = JSON.parse(localStorage.getItem("jwt"));

    const decrypted_data = crypto.AES.decrypt(data, "shubhamraj");
    const de_data = decrypted_data.toString(crypto.enc.Utf8);

    return JSON.parse(de_data);
  } else {
    return false;
  }
};